import { memo } from "react";
import { cn } from "../../tailwind-utils";

export interface KeyboardShortcutProps {
  keys: string[];
  className?: string;
}

export const KeyboardShortcut = memo(function KeyboardShortcut({
  keys,
  className,
}: KeyboardShortcutProps) {
  return (
    <div className={cn("flex items-center gap-0.5", className)}>
      {keys.map((key, index) => (
        <kbd
          className="inline-flex items-center justify-center min-w-4 h-4 px-0.5 text-xxs font-normal leading-none rounded bg-[var(--redo-colors-background-bg-tertiary)] text-[var(--redo-colors-text-text-tertiary-600)]"
          key={index}
        >
          {key}
        </kbd>
      ))}
    </div>
  );
});
